import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { Categories } from '@/features/categories'

const categoriesSearchSchema = z.object({
  parent_id: z.coerce.number().optional(),
  parent_name: z.string().optional(),
  /** Full breadcrumb path from root to current parent: [{ id, name }, ...] */
  path: z
    .array(z.object({ id: z.number(), name: z.string() }))
    .optional()
    .default([]),
  /** 'flat' = all categories, no parent_id; 'tree' = drill-down with parent_id and View children */
  view_mode: z.enum(['flat', 'tree']).optional().default('tree'),
})

export const Route = createFileRoute('/_authenticated/categories/')({
  validateSearch: categoriesSearchSchema,
  component: Categories,
})
